import React from 'react';
import { EventGridCard } from 'fragments';
import { useSelector } from 'react-redux';
import { NotYetScreen } from 'components';
import { Images } from 'assets';
import { sortEventsByDateTimeAsc } from './constants';

export const EventGrid = () => {
    const allEvents = useSelector((state) => state.events.events);
    const sortedEvents = sortEventsByDateTimeAsc(allEvents?.events);

    return (
        <div className="event-grid">
            {sortedEvents?.length ? (
                <>
                    <div className="event-grid-section">
                        {sortedEvents?.map((event, j) => (
                            <React.Fragment key={j}>
                                <EventGridCard event={event} detailBtn={true} />
                            </React.Fragment>
                        ))}
                    </div>
                </>
            ) : (
                <NotYetScreen
                    image={Images.EmptyState}
                    title={'No Events Added Yet'}
                    desc={'It looks like there are no events added yet. Please check back later or explore other sections of our site.'}
                />
            )}
        </div>
    );
};
